import React, { createContext, useState, useEffect, useContext } from 'react';

export const FontSizeContext = createContext();

export const FontSizeProvider = ({ children }) => {
    // Initialize from localStorage or a default
    const [selectedSize, setSelectedSize] = useState(() => {
        const storedSize = localStorage.getItem('userFontSize');
        return storedSize ? JSON.parse(storedSize) : 'medium'; // 'small', 'medium', 'large'
    });

    // Define actual multipliers for each size option
    const sizeMultipliers = {
        small: 0.8,
        medium: 1,
        large: 1.2,
    };

    useEffect(() => {
        // Update CSS variable whenever selectedSize changes
        const multiplier = sizeMultipliers[selectedSize];
        document.documentElement.style.setProperty('--font-size-multiplier', multiplier);
        localStorage.setItem('userFontSize', JSON.stringify(selectedSize));
    }, [selectedSize]);

    const value = {
        selectedSize,
        setSelectedSize,
        sizeMultipliers, // Expose for UI display if needed
    };

    return (
        <FontSizeContext.Provider value={value}>
            {children}
        </FontSizeContext.Provider>
    );
};

// Custom hook for convenience
export const useFontSize = () => useContext(FontSizeContext);